import { call, put, takeLatest } from 'redux-saga/effects'
import * as types from '../../../actions/index.types'
import * as req from '../../../../axios/request/SocietyPortal/SocietyReqs/SocietyReqs'

function* getCountries(action) {
    try {
        const result = yield call(req.getCountriesReq, action);
        console.log("Countries:", result);
        console.log("data :", result.data);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_GET_COUNTRIES_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_COUNTRIES_FAILURE, message: result?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_GET_COUNTRIES_FAILURE, message: e?.message });
    }
}

function* getStates(action) {
    try {
        const result = yield call(req.getStatesReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_GET_STATES_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_STATES_FAILURE, message: result?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_GET_STATES_FAILURE, message: e?.message });
    }
}

function* getCities(action) {
    try {
        const result = yield call(req.getCitiesReq, action);
        if (result.success === true) {
            yield put({ type: types.SOCIETY_GET_CITIES_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.SOCIETY_GET_CITIES_FAILURE, message: result?.message });
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.SOCIETY_GET_CITIES_FAILURE, message: e?.message });
    }
}

export default function* societySaga() {
    yield takeLatest(types.SOCIETY_GET_COUNTRIES, getCountries);
    yield takeLatest(types.SOCIETY_GET_STATES, getStates);
    yield takeLatest(types.SOCIETY_GET_CITIES, getCities);
}
